import { createContext, useContext, useState } from "react";

const DefaultTheme = {
  palette: {
    primary: {
      main: "#13b9ff",
      light: "#6debff",
      dark: "#0089cb",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#e5e5e5",
      light: "#ffffff",
      dark: "#b3b3b3",
      contrastText: "#000000",
    },
    reversePrimary: {
      main: "#ffffff",
    },
  },
};

const ThemeContext = createContext(null);

export default function useTheme() {
  const { theme } = useContext(ThemeContext);
  return theme;
}

export function ThemeProvider({ children, ...props }) {
  const [theme, setTheme] = useState(DefaultTheme);
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
